import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";

export default function slider() {
    var url = location.hostname;
    var protocol = location.protocol ;

    var prevArrow = '<img src="' + tmp_path.site_url + '/wp-content/themes/lot/img/top/icon-arrow_left.png" class="slide-arrow prev-arrow">';
    var nextArrow= '<img src="' + tmp_path.site_url + '/wp-content/themes/lot/img/top/icon-arrow_left.png" class="slide-arrow next-arrow">';

    $('.slider').slick({
        centerMode: true,
        centerPadding: '5%',
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 1500,
        focusOnSelect: true,
        infinite: true,
        touchMove: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    });
}


// WEBPACK FOOTER //
// ./js/module/slider.js